import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { useDidMount, useWillUnmount } from 'rooks';

import { useOnClickOutside } from 'root/lib/hooks';
import DecolineGreenSvg from './svgs/Notification/DecolineGreen.svg';
import DecolineSvg from './svgs/Notification/Decoline.svg';
import { ModalContainer, ClickableContainer } from './styledComponents';
import useWorkshopSfx from '../../../hooks/useWorkshopSfx';

const NotificationModal = ({ config, closeModal: propClose }) => {
  const timeout = React.useRef(null);

  const { status, header, description, disableAutoFade, onClose = () => {} } = config;

  const isFinished = status === 'finished';

  const { playTap, playSfxFromMap, audioMap } = useWorkshopSfx();

  const closeModal = (options) => {
    propClose(options);
    onClose();
  };

  useDidMount(() => {
    // we only play the special sfx is the activity clicked is finished
    if (isFinished) {
      playSfxFromMap(audioMap.notification_launch);
    } else {
      playTap();
    }
    if (!disableAutoFade) {
      timeout.current = setTimeout(() => closeModal({ withFade: true }), 3000);
    }
  });

  const handleOnTextClick = () => {
    playTap(true);
    clearTimeout(timeout.current);
    closeModal();
  };

  useWillUnmount(() => {
    clearTimeout(timeout.current);
  });

  const clickRef = useOnClickOutside(handleOnTextClick);

  return (
    <ClickableContainer
      ref={clickRef}
      role="dialog"
      aria-labelledby="notification-modal-title"
      onClick={handleOnTextClick}
      data-testid="workshop-notification-modal"
      data-dd-action-name="notification-modal"
    >
      <StyledContainer isFinished={isFinished}>
        <StyledHeader
          id="notification-modal-title"
          data-testid="workshop-notification-modal-message"
        >
          {header}
        </StyledHeader>
        <img src={isFinished ? DecolineGreenSvg : DecolineSvg} alt="" />
        <StyledDescription data-testid="workshop-notification-modal-explanation">{description}</StyledDescription>
      </StyledContainer>
    </ClickableContainer>
  );
};

NotificationModal.propTypes = {
  config: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default NotificationModal;

const StyledContainer = styled(ModalContainer)`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-evenly;
`;

const StyledDescription = styled.p`
  margin: 0;
  opacity: 0.8;
  font-family: Open Sans;
  font-size: 17;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
`;

const StyledHeader = styled.h3`
  margin: 0;
  font-family: Quicksand Medium;
  font-size: 27;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
`;
